<template>
  <h1>
    <kinesis-element tag="span" type="rotate" :strength="5">k</kinesis-element>
    <kinesis-element tag="span" :strength="-5">i</kinesis-element>
    <kinesis-element type="rotate" tag="span" :strength="-10"
      >n</kinesis-element
    >
    <kinesis-element tag="span" :strength="10">e</kinesis-element>
    <kinesis-element tag="span" :strength="5">s</kinesis-element>
    <kinesis-element type="rotate" tag="span" :strength="-5">i</kinesis-element>
    <kinesis-element tag="span" :strength="-10">s</kinesis-element>
  </h1>
</template>

<script>
import { KinesisElement } from "vue-kinesis";
export default {
  components: {
    KinesisElement
  }
};
</script>

<style lang="scss" scoped>
h1 {
  position: relative;
  display: flex;
  color: $color-brown;
  font-size: 72px;
  span {
    // background-color: salmon;
    // padding: 10px;
    &:nth-of-type(1) {
      margin-top: 0px;
    }
    &:nth-of-type(2) {
      margin-top: -20px;
    }
    &:nth-of-type(3) {
      margin-top: -7px;
    }
    &:nth-of-type(4) {
      margin-top: 8px;
    }
    &:nth-of-type(5) {
      margin-top: -13px;
    }
    &:nth-of-type(6) {
      margin-top: -5px;
    }
    &:nth-of-type(7) {
      margin-top: 0px;
    }
    &:nth-of-type(8) {
      margin-top: -6px;
    }
  }
}

.animation-fall {
  animation: fall 1500ms linear both;
}

/* Generated with Bounce.js. Edit at http://bouncejs.com#%7Bs%3A%5B%7BT%3A%22t%22%2Ce%3A%22b%22%2Cd%3A1200%2CD%3A0%2Cf%3A%7Bx%3A0%2Cy%3A-200%7D%2Ct%3A%7Bx%3A0%2Cy%3A0%7D%2Cs%3A1%2Cb%3A5%7D%2C%7BT%3A%22r%22%2Ce%3A%22b%22%2Cd%3A1500%2CD%3A0%2Cf%3A-45%2Ct%3A0%2Cs%3A1%2Cb%3A4%7D%5D%7D */

@keyframes fall {
  0% {
    -webkit-transform: matrix3d(
      0.707,
      -0.707,
      0,
      0,
      0.707,
      0.707,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -200,
      0,
      1
    );
    transform: matrix3d(
      0.707,
      -0.707,
      0,
      0,
      0.707,
      0.707,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -200,
      0,
      1
    );
  }
  3.2% {
    -webkit-transform: matrix3d(
      0.851,
      -0.526,
      0,
      0,
      0.526,
      0.851,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -113.607,
      0,
      1
    );
    transform: matrix3d(
      0.851,
      -0.526,
      0,
      0,
      0.526,
      0.851,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -113.607,
      0,
      1
    );
  }
  4.7% {
    -webkit-transform: matrix3d(
      0.908,
      -0.419,
      0,
      0,
      0.419,
      0.908,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -67.367,
      0,
      1
    );
    transform: matrix3d(
      0.908,
      -0.419,
      0,
      0,
      0.419,
      0.908,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -67.367,
      0,
      1
    );
  }
  6.33% {
    -webkit-transform: matrix3d(
      0.954,
      -0.299,
      0,
      0,
      0.299,
      0.954,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -22.258,
      0,
      1
    );
    transform: matrix3d(
      0.954,
      -0.299,
      0,
      0,
      0.299,
      0.954,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -22.258,
      0,
      1
    );
  }
  9.41% {
    -webkit-transform: matrix3d(
      0.996,
      -0.091,
      0,
      0,
      0.091,
      0.996,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      36.429,
      0,
      1
    );
    transform: matrix3d(
      0.996,
      -0.091,
      0,
      0,
      0.091,
      0.996,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      36.429,
      0,
      1
    );
  }
  9.53% {
    -webkit-transform: matrix3d(
      0.996,
      -0.084,
      0,
      0,
      0.084,
      0.996,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      37.883,
      0,
      1
    );
    transform: matrix3d(
      0.996,
      -0.084,
      0,
      0,
      0.084,
      0.996,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      37.883,
      0,
      1
    );
  }
  12.65% {
    -webkit-transform: matrix3d(
      0.998,
      0.065,
      0,
      0,
      -0.065,
      0.998,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      55.164,
      0,
      1
    );
    transform: matrix3d(
      0.998,
      0.065,
      0,
      0,
      -0.065,
      0.998,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      55.164,
      0,
      1
    );
  }
  14.11% {
    -webkit-transform: matrix3d(
      0.994,
      0.11,
      0,
      0,
      -0.11,
      0.994,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      52.098,
      0,
      1
    );
    transform: matrix3d(
      0.994,
      0.11,
      0,
      0,
      -0.11,
      0.994,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      52.098,
      0,
      1
    );
  }
  16.34% {
    -webkit-transform: matrix3d(
      0.988,
      0.152,
      0,
      0,
      -0.152,
      0.988,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      39.237,
      0,
      1
    );
    transform: matrix3d(
      0.988,
      0.152,
      0,
      0,
      -0.152,
      0.988,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      39.237,
      0,
      1
    );
  }
  18.72% {
    -webkit-transform: matrix3d(
      0.986,
      0.166,
      0,
      0,
      -0.166,
      0.986,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      20.966,
      0,
      1
    );
    transform: matrix3d(
      0.986,
      0.166,
      0,
      0,
      -0.166,
      0.986,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      20.966,
      0,
      1
    );
  }
  19.94% {
    -webkit-transform: matrix3d(
      0.987,
      0.163,
      0,
      0,
      -0.163,
      0.987,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      11.873,
      0,
      1
    );
    transform: matrix3d(
      0.987,
      0.163,
      0,
      0,
      -0.163,
      0.987,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      11.873,
      0,
      1
    );
  }
  23.62% {
    -webkit-transform: matrix3d(
      0.992,
      0.128,
      0,
      0,
      -0.128,
      0.992,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -8.06,
      0,
      1
    );
    transform: matrix3d(
      0.992,
      0.128,
      0,
      0,
      -0.128,
      0.992,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -8.06,
      0,
      1
    );
  }
  24.32% {
    -webkit-transform: matrix3d(
      0.993,
      0.118,
      0,
      0,
      -0.118,
      0.993,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -10.22,
      0,
      1
    );
    transform: matrix3d(
      0.993,
      0.118,
      0,
      0,
      -0.118,
      0.993,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -10.22,
      0,
      1
    );
  }
  27.23% {
    -webkit-transform: matrix3d(
      0.997,
      0.075,
      0,
      0,
      -0.075,
      0.997,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -13.852,
      0,
      1
    );
    transform: matrix3d(
      0.997,
      0.075,
      0,
      0,
      -0.075,
      0.997,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -13.852,
      0,
      1
    );
  }
  29.93% {
    -webkit-transform: matrix3d(
      0.999,
      0.037,
      0,
      0,
      -0.037,
      0.999,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -11.455,
      0,
      1
    );
    transform: matrix3d(
      0.999,
      0.037,
      0,
      0,
      -0.037,
      0.999,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -11.455,
      0,
      1
    );
  }
  34.51% {
    -webkit-transform: matrix3d(
      1,
      -0.009,
      0,
      0,
      0.009,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -2.93,
      0,
      1
    );
    transform: matrix3d(
      1,
      -0.009,
      0,
      0,
      0.009,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -2.93,
      0,
      1
    );
  }
  35.54% {
    -webkit-transform: matrix3d(
      1,
      -0.016,
      0,
      0,
      0.016,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -1.216,
      0,
      1
    );
    transform: matrix3d(
      1,
      -0.016,
      0,
      0,
      0.016,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -1.216,
      0,
      1
    );
  }
  41.04% {
    -webkit-transform: matrix3d(
      1,
      -0.031,
      0,
      0,
      0.031,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      3.433,
      0,
      1
    );
    transform: matrix3d(
      1,
      -0.031,
      0,
      0,
      0.031,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      3.433,
      0,
      1
    );
  }
  41.72% {
    -webkit-transform: matrix3d(
      1,
      -0.031,
      0,
      0,
      0.031,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      3.479,
      0,
      1
    );
    transform: matrix3d(
      1,
      -0.031,
      0,
      0,
      0.031,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      3.479,
      0,
      1
    );
  }
  52.15% {
    -webkit-transform: matrix3d(
      1,
      -0.007,
      0,
      0,
      0.007,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -0.374,
      0,
      1
    );
    transform: matrix3d(
      1,
      -0.007,
      0,
      0,
      0.007,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -0.374,
      0,
      1
    );
  }
  56.3% {
    -webkit-transform: matrix3d(
      1,
      0.001,
      0,
      0,
      -0.001,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -0.874,
      0,
      1
    );
    transform: matrix3d(
      1,
      0.001,
      0,
      0,
      -0.001,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -0.874,
      0,
      1
    );
  }
  63.26% {
    -webkit-transform: matrix3d(
      1,
      0.006,
      0,
      0,
      -0.006,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -0.224,
      0,
      1
    );
    transform: matrix3d(
      1,
      0.006,
      0,
      0,
      -0.006,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      -0.224,
      0,
      1
    );
  }
  70.87% {
    -webkit-transform: matrix3d(
      1,
      0.003,
      0,
      0,
      -0.003,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0.219,
      0,
      1
    );
    transform: matrix3d(
      1,
      0.003,
      0,
      0,
      -0.003,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0.219,
      0,
      1
    );
  }
  80% {
    -webkit-transform: matrix3d(
      1,
      -0.001,
      0,
      0,
      0.001,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1,
      -0.001,
      0,
      0,
      0.001,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  85.49% {
    -webkit-transform: matrix3d(
      1,
      -0.001,
      0,
      0,
      0.001,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1,
      -0.001,
      0,
      0,
      0.001,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  100% {
    -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
}
</style>
